var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Payment } from '.';
import { AuthStatus, AuthMethod, } from '@lean-body/src/interfaces';
import { LoggedInPlatForm, SessionStorage } from '@lean-body/src/infra';
import { routes } from '../route';
import { bind } from 'bind-decorator';
/*=============================================
= Service =
=============================================*/
// アカウントサービス。meのキャッシュと認証や退会などログイン情報に関わる箇所を変更するサービス
export class AccountService {
    constructor(authState, apiClient, fbClient, lineClient, appleClient, localStorage, navigate, config) {
        Object.defineProperty(this, "apiClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "fbClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lineClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "appleClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "authState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "localStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sessionStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "meRepo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "navigate", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.apiClient = apiClient;
        this.fbClient = fbClient;
        this.lineClient = lineClient;
        this.appleClient = appleClient;
        this.authState = authState;
        this.localStorage = localStorage;
        this.sessionStorage = new SessionStorage();
        this.meRepo = new MeRepository(apiClient, config);
        this.navigate = navigate;
    }
    /*---------- Query ----------*/
    fetchMe(p) {
        return __awaiter(this, void 0, void 0, function* () {
            const me = this.meRepo.get(p);
            me.then((u) => {
                this.userId = u.id;
            });
            return me;
        });
    }
    // AuthorizationAPIへのリクエストとauthStateの更新
    authorization() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.apiClient
                ._authorization()
                .then((v) => {
                this.authState.setAuthed();
                this.localStorage.saveLoginState(true);
                return v;
            })
                .catch((e) => {
                if (e.isForbiddenError) {
                    const forbiddenError = e;
                    if (forbiddenError.isDormant)
                        this.authState.setDormant();
                    else if (forbiddenError.isFuture)
                        this.authState.setFuture();
                    else if (forbiddenError.isPaymentNotFound || forbiddenError.isPaymentExpired)
                        this.authState.setNosubscription();
                }
                throw e;
            });
        });
    }
    reloadMe() {
        this.meRepo.reloadCache();
    }
    clearMe() {
        this.meRepo.clearCache();
    }
    isPaymentRegistered() {
        return __awaiter(this, void 0, void 0, function* () {
            const me = yield this.fetchMe();
            return me.paymentRegistered;
        });
    }
    // ログインしているか
    get loggedIn() {
        return !!this.localStorage.loadLoginState();
    }
    /**
     * 認証されているか取得
     */
    get authed() {
        return this.authStatus === AuthStatus.Authed;
    }
    /**
     * 認証状態を取得
     */
    get authStatus() {
        return this.authState.authStatus;
    }
    /*---------- Command ----------*/
    createUser(params, tracker) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.apiClient.createUser({
                    email: params.email,
                    password: params.password,
                });
                this.onAuthed(result, tracker, AuthMethod.Email);
            }
            catch (err) {
                this.onUnAuthed();
                throw err;
            }
        });
    }
    signUp(params, tracker) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.apiClient.signUp({
                    email: params.email,
                    password: params.password,
                    paymentMethodID: params.paymentMethodID,
                    subPlanID: params.subPlanID,
                    corporationEmployee: params.corporationEmployee,
                    invitationCode: params.invitationCode,
                    collaborationCode: params.collaborationCode,
                });
                this.onAuthed(result, tracker, AuthMethod.Email);
                this.afterCCRegister();
                return result.user;
            }
            catch (err) {
                this.onUnAuthed();
                throw err;
            }
        });
    }
    fbSigInWithAndroid(token_1, tracker_1) {
        return __awaiter(this, arguments, void 0, function* (token, tracker, isSignUp = false) {
            const auth = {
                accessToken: token,
                expiresIn: 0,
                signedRequest: '',
                userID: '',
            };
            return this.postFBAccessToken(auth, isSignUp, tracker);
        });
    }
    fbSignIn(tracker_1) {
        return __awaiter(this, arguments, void 0, function* (tracker, isSignUp = false) {
            if (this.fbClient.auth) {
                return this.postFBAccessToken(this.fbClient.auth, isSignUp, tracker);
            }
            else {
                const auth = yield this.fbClient.login();
                return this.postFBAccessToken(auth, isSignUp, tracker);
            }
        });
    }
    lineSignIn(tracker) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                oauthCode: this.lineClient.oauthCode,
            };
            const result = yield this.apiClient.lineSignIn(params);
            this.onAuthed(result, tracker, AuthMethod.LINE);
            this.localStorage.saveLoggedInPlatform(LoggedInPlatForm.line);
            return result;
        });
    }
    amazonPaySignup(amazonCheckoutSessionId, tracker) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.apiClient.signupForAmazonPay(amazonCheckoutSessionId);
            // AmazonPayでSingupしているが、サーバー側ではEmailでのログインとして処理していて、SigninページにAmazonPayボタンは実装していない
            // 将来、Amazonログインを実装した時、AuthMethod.Amazonを実装する
            this.onAuthed(res, tracker, AuthMethod.Email);
        });
    }
    getNonce() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.apiClient.nonce();
        });
    }
    postFBAccessToken(auth, isSignUp, tracker) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const res = yield this.apiClient.fbSignIn({ accessToken: auth.accessToken });
                this.onAuthed(res, tracker, AuthMethod.Facebook);
                this.localStorage.saveLoggedInPlatform(LoggedInPlatForm.facebook);
                return res;
            }
            catch (err) {
                this.onUnAuthed();
                throw err;
            }
        });
    }
    signIn(params, tracker) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const result = yield this.apiClient.signIn(params);
                yield this.onAuthed(result, tracker, AuthMethod.Email);
                this.localStorage.resetLoggedInPlatform();
            }
            catch (err) {
                this.onUnAuthed();
                throw err;
            }
        });
    }
    /**
     * @param redirectTo 省略時はログイン画面へ遷移する
     */
    signOut(redirectTo) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiClient.signOut();
            this.onUnAuthed();
            this.navigate(redirectTo !== null && redirectTo !== void 0 ? redirectTo : routes.SIGNIN.compile());
        });
    }
    /*
     * 退会予約
     */
    scheduleUnsubscribe() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiClient.scheduleUnsubscribe();
            this.meRepo.clearCache();
        });
    }
    /*
     * Androidアカウント削除
     */
    destroyAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.apiClient.destroyAccount();
            this.onUnAuthed();
            this.navigate(routes.SIGNIN.compile());
        });
    }
    // 休眠会員になる
    dormantAccount(month) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.apiClient.dormantAccount(month).then(() => {
                this.meRepo.reloadCache();
                this.authState.setDormant();
            });
        });
    }
    // 休眠会員から復活
    reactivateAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.apiClient.reactivateAccount().then(() => {
                this.meRepo.clearCache();
                this.authState.setUndormant();
            });
        });
    }
    registerPayment(planID, paymentMethodID, corporationEmployeeParams, invitationCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const rs = yield this.apiClient.registerPayment({
                subPlanID: planID,
                paymentMethodID: paymentMethodID,
                corporationEmployee: !corporationEmployeeParams
                    ? null
                    : corporationEmployeeParams.toJson(),
                invitationCode,
            });
            this.afterCCRegister();
            return rs;
        });
    }
    afterCCRegister() {
        return __awaiter(this, void 0, void 0, function* () {
            // set user id
            const user = yield this.meRepo.get();
            this.userId = user.id;
            this.authState.setAuthed();
            yield this.meRepo.reloadCache();
            this.apiClient.saveLinebotConversionLog();
        });
    }
    // SignInWithAppleを利用して認証を行う
    signInWithApple(clientId, redirectUri) {
        return __awaiter(this, void 0, void 0, function* () {
            const { nonce } = yield this.getNonce();
            yield this.appleClient.authenticate(nonce, clientId, redirectUri);
        });
    }
    // SignInWithApple認証後の設定
    onAuthedSignInWithApple(isSignUp, didSubExpired, tracker) {
        return __awaiter(this, void 0, void 0, function* () {
            this.localStorage.saveLoggedInPlatform(LoggedInPlatForm.apple);
            this.authState.setAuthed();
            if (didSubExpired)
                this.authState.setNosubscription();
            const authResult = {
                isSignUp,
            };
            this.onAuthed(authResult, tracker, AuthMethod.Apple);
        });
    }
    onUnAuthed() {
        this.meRepo.clearCache();
        this.authState.setUnAuthed();
        this.localStorage.saveLoginState(false);
        this.sessionStorage.setSkipBeginnerMissionDialogAutoOpen(false);
    }
    /*---------- private methods ----------*/
    onAuthed(result, tracker, authMethod) {
        return __awaiter(this, void 0, void 0, function* () {
            this.localStorage.removeBeginnerMissionAchievedCount();
            this.localStorage.saveLoginState(true);
            this.sessionStorage.setSkipBeginnerMissionDialogAutoOpen(!!result.isSignUp);
            let email;
            if (result.user) {
                this.userId = result.user.id;
                this.meRepo.set(result.user);
                email = result.user.email;
            }
            else {
                const me = yield this.fetchMe();
                this.userId = me.id;
                email = me.email;
            }
            tracker.userId = this.userId;
            if (result.isSignUp) {
                this.authState.setNosubscription();
                tracker.trackSignUp(this.userId, email);
            }
            else {
                tracker.trackSignIn(this.userId, email, authMethod);
            }
        });
    }
}
__decorate([
    bind
], AccountService.prototype, "dormantAccount", null);
/*=============================================
= Repositories =
=============================================*/
export class Me {
    constructor(meData, config) {
        Object.defineProperty(this, "id", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isDormant", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "email", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "payment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "passwordEnabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "invoiceFailed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unsubscribeScheduledAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "deletedAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "createdAt", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "canFriendInvitation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.id = meData.id;
        this.email = meData.email;
        this.userName = meData.userName;
        this.isDormant = meData.isDormant;
        this.payment = meData.payment ? new Payment(meData.payment, config) : null;
        this.passwordEnabled = meData.passwordEnabled;
        this.invoiceFailed = meData.invoiceFailed;
        this.unsubscribeScheduledAt = meData.unsubscribeScheduledAt ? meData.unsubscribeScheduledAt : null;
        this.deletedAt = meData.deletedAt ? meData.deletedAt : null;
        this.createdAt = meData.createdAt ? meData.createdAt : null;
        this.canFriendInvitation = meData.canFriendInvitation;
    }
    get paymentRegistered() {
        return !!this.payment;
    }
    /**
     * LINE登録ユーザーかどうか判定
     * @todo APIからOAuthの情報も一緒に返すようにして判定
     */
    get isLineUser() {
        // line登録ユーザーはメアドにlb-tmpの文字列が含まれる
        return this.email.indexOf('lb-tmp') != -1;
    }
    /*
     * プラン変更ができるか判定
     *
     * 変更できないケース：
     * 1. 退会をしてない
     * 2. 休眠会員ではない
     * 3. すでに切り替えのプランがある
     * 4. 新（2024年価格改定）キャンペーンプランではない
     */
    get canChangePlans() {
        return (this.payment &&
            !this.unsubscribeScheduledAt &&
            !this.deletedAt &&
            !this.isDormant &&
            !this.payment.queuedPlan &&
            !(this.payment.currentPlan.isPlanAfter2024May15PriceChange && this.payment.currentPlan.isCampaignPlan()));
    }
    get isDormantAvailable() {
        var _a;
        return (!this.isDormant &&
            !this.unsubscribeScheduledAt &&
            this.payment &&
            (this.payment.isStripePayment() || this.payment.isAmazonPayUser()) &&
            !this.payment.isFreeTrialUser() &&
            !this.payment.isBillingGrace &&
            !((_a = this.payment.coachingPayment) === null || _a === void 0 ? void 0 : _a.isValid));
    }
    get canChangeCreditCard() {
        return !this.unsubscribeScheduledAt && !this.deletedAt;
    }
}
export class MeRepository {
    constructor(apiClient, config) {
        Object.defineProperty(this, "apiClient", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cache", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "fetchMeDeffered", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.apiClient = apiClient;
        this.config = config;
    }
    get(p) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cache && !(p === null || p === void 0 ? void 0 : p.nocache)) {
                return this.cache;
            }
            this.fetchMeDeffered = this.apiClient
                ._fetchMe()
                .then((meData) => {
                const me = new Me(meData, this.config);
                this.cache = me;
                return me;
            })
                .catch((err) => {
                this.clearCache();
                throw err;
            });
            return this.fetchMeDeffered;
        });
    }
    set(meData) {
        return __awaiter(this, void 0, void 0, function* () {
            this.cache = new Me(meData, this.config);
        });
    }
    reloadCache() {
        return __awaiter(this, void 0, void 0, function* () {
            this.clearCache();
            yield this.get();
        });
    }
    clearCache() {
        this.cache = null;
    }
}
/*=============================================
= Domain Models =
=============================================*/
export class AuthState {
    constructor() {
        Object.defineProperty(this, "authStatus", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: AuthStatus.Unauth
        });
    }
    setAuthed() {
        this.authStatus = AuthStatus.Authed;
    }
    setUnAuthed() {
        this.authStatus = AuthStatus.Unauth;
    }
    setDormant() {
        this.authStatus = AuthStatus.Dormant;
    }
    setUndormant() {
        this.authStatus = AuthStatus.Authed;
    }
    setFuture() {
        this.authStatus = AuthStatus.Future;
    }
    setNosubscription() {
        this.authStatus = AuthStatus.NoSubscription;
    }
}
